import type { GridApi } from "~/components/grid/AgGrid";

import formatLocaleNumber from "~/helpers/localeNumberFormat";
import i18n from "~/i18n/i18n";

export interface GridRowCountFooterInput {
	shown: number;
	total?: number | null;
}

const asCount = (value: number): number => (Number.isFinite(value) && value > 0 ? Math.floor(value) : 0);

const formatGridRowCountFooter = ({ shown, total }: GridRowCountFooterInput): string => {
	const safeShown = asCount(shown);
	const hasTotal = typeof total === "number" && Number.isFinite(total) && total > 0;
	if (hasTotal && (total as number) > safeShown) {
		const grandTotal = total as number;
		return i18n.t("common:grid.rowCount.subset", {
			count: grandTotal,
			shown: formatLocaleNumber(safeShown),
			total: formatLocaleNumber(grandTotal)
		});
	}
	const count = hasTotal ? Math.max(total as number, safeShown) : safeShown;
	return i18n.t("common:grid.rowCount.rows", { count, qty: formatLocaleNumber(count) });
};

export const isGridReloading = (api: Pick<GridApi, "getDisplayedRowAtIndex">): boolean =>
	api.getDisplayedRowAtIndex(0)?.stub === true;

export default formatGridRowCountFooter;
